import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

import ProtectedLayout from 'src/routes/ProtectedLayout';
import VehiculosBulkEdit from './content/applications/Vehiculos/VehiculosBulkEdit';
import VehiculosAsignados from './content/applications/Vehiculos/VehiculosAsignados';
import UsuariosSinUso from './content/applications/Reportes/UsuariosSinUso';
import MantenimientosPendientes from './content/applications/Reportes/MantenimientosPendientes';
import MantenimientosPorVencer from './content/applications/Reportes/MantenimientosPorVencer';
import BuzonSugerencias from './content/applications/Soporte/BuzonSugerencias';


const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Páginas
const Overview = Loader(lazy(() => import('src/content/overview')));
const Crypto = Loader(lazy(() => import('src/content/dashboards/Crypto')));
const Messenger = Loader(lazy(() => import('src/content/applications/Messenger')));
const UserProfile = Loader(lazy(() => import('src/content/applications/Users/profile')));
const UserSettings = Loader(lazy(() => import('src/content/applications/Users/settings')));
const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));
const LoginPage = Loader(lazy(() => import('src/content/pages/Login')));
const VehiculosList = Loader(lazy(() => import('src/content/applications/Vehiculos')));
const MembresiaPage = Loader(lazy(() => import('src/content/applications/Membresia')));

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      // ✅ Ruta pública
      { path: 'login', element: <LoginPage /> },

      // ✅ Rutas protegidas
      {
        element: (
          <ProtectedLayout>
            <SidebarLayout />
          </ProtectedLayout>
        ),
        children: [
          { path: '', element: <Overview /> },
          { path: 'overview', element: <Navigate to="/" replace /> },
          {
            path: 'membresia',
            children: [
              { path: '', element: <MembresiaPage /> }
              
            ]
          },

          {
            path: 'status',
            children: [
              { path: '', element: <Navigate to="404" replace /> },
              { path: '404', element: <Status404 /> },
              { path: '500', element: <Status500 /> },
              { path: 'maintenance', element: <StatusMaintenance /> },
              { path: 'coming-soon', element: <StatusComingSoon /> }
            ]
          },
          // ✅ Tus rutas principales (vehículos)
          {
            path: 'gestion',
            children: [
              { path: '', element: <Navigate to="vehiculos" replace /> },
              { path: 'vehiculos', element: <VehiculosList /> },
              { path: 'proximosCambios', element: <VehiculosBulkEdit /> },
              { path: 'vehiculosAsignados', element: <VehiculosAsignados /> }
            ]
          },
          {
            path: 'reportes',
            children: [
              { path: '', element: <Navigate to="sinUsarApp" replace /> },
              { path: 'sinUsarApp', element: <UsuariosSinUso  /> },
              { path: 'mantenimientosPendientes', element: <MantenimientosPendientes/> },
              { path: 'mantenimientosPorVencer', element: <MantenimientosPorVencer/> }
            ]
          },
          {
            path: 'soporte',
            children: [
              { path: '', element: <Navigate to="buzonSugerencias" replace /> },
              { path: 'buzonSugerencias', element: <BuzonSugerencias /> }
            ]
          },
          // ✅ Dashboards y management
          {
            path: 'dashboards',
            children: [
              { path: '', element: <Navigate to="crypto" replace /> },
              { path: 'crypto', element: <Crypto /> },
              { path: 'messenger', element: <Messenger /> }
            ]
          },
          {
            path: 'management',
            children: [
              {
                path: 'profile',
                children: [
                  { path: '', element: <Navigate to="details" replace /> },
                  { path: 'details', element: <UserProfile /> },
                  { path: 'settings', element: <UserSettings /> }
                ]
              }
            ]
          },

          // ✅ Ruta por defecto
          { path: '*', element: <Status404 /> }
        ]
      }
    ]
  }
];

export default routes;
